import { render, staticRenderFns } from "./ClientsReport.vue?vue&type=template&id=393877aa"
import script from "./ClientsReport.vue?vue&type=script&lang=js"
export * from "./ClientsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Freports%2Fclients-report%2FClientsReport.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports